import { MetadataItem, MetadataWithProperty, MetadataWithName } from './types';

export const isMetadataWithProperty = (meta?: MetadataItem): meta is MetadataWithProperty =>
  !!(meta && 'property' in meta && meta.property && meta.property.length > 0);
export const isMetadataWithName = (meta?: MetadataItem): meta is MetadataWithName =>
  !!(meta && 'name' in meta && meta.name && meta.name.length > 0);

export const makeMetadataKey = (meta: MetadataItem) => {
  if (isMetadataWithName(meta)) {
    return `nmdp-mn-${meta.name}`;
  }
  if (isMetadataWithProperty(meta)) {
    return `nmdp-mp-${meta.property}`;
  }
  throw new Error('Invalid metadata item detected', {
    cause: 'No name or property value specified',
  });
};

export const mapFromObject = <T extends {}>(source: T): MetadataItem[] => {
  if (!source) {
    return [];
  }
  return Object.entries(source).reduce((filtered, kvp) => {
    // Check if a value is set
    const [key, value] = kvp;
    if (typeof value === 'string') {
      const trimmedValue = value.trim();
      if (trimmedValue?.length) {
        filtered.push(
          // Check if the key begins with og:
          key.startsWith('og:')
            ? { property: key, content: trimmedValue }
            : { name: key, content: trimmedValue }
        );
      }
    }
    return filtered;
  }, [] as MetadataItem[]);
};
